import React, { useState } from "react";
// Components
import { Button } from "src/VirtualOMS/components";
// Types
import { OrderTableRow } from "src/VirtualOMS/types/order";
// Utilities
import { Modal } from "src/Components";
import FillOrderModalUI from "src/VirtualOMS/FillOrderModalUI";

interface Props {
  rows: OrderTableRow[];
  isTrade: boolean;
  onAction: () => void;
}

const OrderTable: React.FC<Props> = ({ rows, isTrade, onAction }) => {
  const [openModalId, setOpenModalId] = useState<number | null>(null);

  return (
    <div className="overflow-x-auto p-4">
      <table className="min-w-full border border-gray-300 text-sm text-left text-gray-700">
        <thead className="bg-gray-100 text-xs uppercase">
          <tr>
            <th className="border px-4 py-2">ID</th>
            <th className="border px-4 py-2">Name</th>
            <th className="border px-4 py-2">Price</th>
            <th className="border px-4 py-2">Volume</th>
            <th className="border px-4 py-2">Executed Volume</th>
            <th className="border px-4 py-2">Side</th>
            <th className="border px-4 py-2">Status</th>
            <th className="border px-4 py-2">Created At</th>
            {!isTrade ? (
              <th className="border px-4 py-2">Fill Order</th>
            ) : (
              <></>
            )}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr className="hover:bg-gray-50" key={row.id}>
              <td className="border px-4 py-2">{row.id}</td>
              <td className="border px-4 py-2">{row.name}</td>
              <td className="border px-4 py-2">{row.price}</td>
              <td className="border px-4 py-2">{row.volume}</td>
              <td className="border px-4 py-2">{row.executedVolume}</td>
              <td className="border px-4 py-2">{row.sideStr}</td>
              <td className="border px-4 py-2">{row.statusStr}</td>
              <td className="border px-4 py-2">{row.createStr}</td>
              {!isTrade ? (
                <td className="border px-4 py-2">
                  <Button
                    label="Fill Order"
                    onClick={() => setOpenModalId(row.id)}
                    disabled={row.executedVolume >= row.volume}
                  />
                  {openModalId === row.id ? (
                    <Modal
                      onClose={() => setOpenModalId(-1)}
                      UI={
                        <FillOrderModalUI
                          id={row.id}
                          onClose={() => setOpenModalId(-1)}
                          onSuccess={onAction}
                        />
                      }
                    />
                  ) : (
                    <></>
                  )}
                </td>
              ) : (
                <></>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderTable;
